import { locationChange } from '../actions/locationChangedAction.js';

export function startListener(history, store) {
    store.dispatch(
        locationChange({
            history,
        })
    );

    history.listen((location) => {
        console.log('location :', location);
        store.dispatch(
            locationChange({
                history,
            })
        );
    });
}
